import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';

import { FuseSharedModule } from '@fuse/shared.module';

import { MatIconModule, MatTooltipModule } from '@angular/material';
import { TabGeneralComponent } from './tab-general.component';
@NgModule({
    declarations: [
        TabGeneralComponent
    ],
    imports: [
        TranslateModule,

        MatIconModule,
        FuseSharedModule,
        MatInputModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatTooltipModule,
        MatSlideToggleModule,
        NgxMaskModule.forRoot(),
    ],
    exports: [
        TabGeneralComponent
    ]
})
export class TabGeneralModule { }
